import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('add_your_teammates_here_ers_or_requesters_later'),
    alert: defineMessage('we_wont_send_any_notifi_using_approvalmax_later'),
    description: defineMessage('enter_the_email_address_semicolon_or_whitespace'),
};
